(function (root) {
 'use strict';
 const core=typeof module!=='undefined'?require('./solstice-published-checkout'):root.SolsticePublishedCheckout;
 const copy={
 fr:{ready:'Livraison en 4 à 5 jours ouvrés',later:'Précommande : expédition sous environ 3 semaines',label:'Envoi prévu',detail:'Bijoux en précommande',count:'Quantité en précommande'},
 en:{ready:'Delivery in 4 to 5 working days',later:'Preorder: dispatch in approximately 3 weeks',label:'Shipping estimate',detail:'Preordered pieces',count:'Preorder quantity'},
 de:{ready:'Lieferung in 4 bis 5 Werktagen',later:'Vorbestellung: Versand in etwa 3 Wochen',label:'Geplanter Versand',detail:'Vorbestellte Schmuckstücke',count:'Vorbestellte Anzahl'},
 es:{ready:'Entrega en 4 a 5 días laborables',later:'Preventa: envío en unas 3 semanas',label:'Envío previsto',detail:'Joyas en preventa',count:'Cantidad en preventa'},
 fi:{ready:'Toimitus 4 tai 5 arkipäivässä',later:'Ennakkotilaus: lähetys noin 3 viikon kuluttua',label:'Arvioitu lähetys',detail:'Ennakkotilatut korut',count:'Ennakkotilauksen määrä'},
 hu:{ready:'Szállítás 4 vagy 5 munkanapon belül',later:'Előrendelés: feladás körülbelül 3 hét múlva',label:'Várható feladás',detail:'Előrendelt ékszerek',count:'Előrendelt mennyiség'},
 it:{ready:'Consegna in 4 o 5 giorni lavorativi',later:'Preordine: spedizione tra circa 3 settimane',label:'Spedizione prevista',detail:'Gioielli in preordine',count:'Quantità in preordine'},
 nl:{ready:'Levering binnen 4 tot 5 werkdagen',later:'Voorbestelling: verzending over ongeveer 3 weken',label:'Verwachte verzending',detail:'Voorbestelde sieraden',count:'Aantal voorbesteld'},
 pl:{ready:'Dostawa w ciągu 4 do 5 dni roboczych',later:'Przedsprzedaż: wysyłka za około 3 tygodnie',label:'Planowana wysyłka',detail:'Biżuteria w przedsprzedaży',count:'Liczba w przedsprzedaży'},
 sv:{ready:'Leverans inom 4 till 5 arbetsdagar',later:'Förbeställning: skickas om cirka 3 veckor',label:'Planerad leverans',detail:'Förbeställda smycken',count:'Förbeställt antal'}
};
 const international={fr:'Livraison selon votre destination',en:'Delivery according to your destination',de:'Lieferung je nach Zielland',es:'Entrega según tu destino',fi:'Toimitus kohdemaan mukaan',hu:'Szállítás a célországtól függően',it:'Consegna in base alla destinazione',nl:'Levering afhankelijk van je bestemming',pl:'Dostawa zależnie od miejsca docelowego',sv:'Leverans beroende på destination'};
 const splitNotice={fr:'Si votre commande contient aussi des bijoux disponibles, ils partent d’abord. Le second colis est sans supplément.',en:'If your order also contains available pieces, they ship first. The second parcel is free of charge.',de:'Wenn Ihre Bestellung auch verfügbare Schmuckstücke enthält, werden diese zuerst versendet. Das zweite Paket ist ohne Aufpreis.',es:'Si tu pedido también contiene joyas disponibles, se envían primero. El segundo paquete no tiene coste adicional.',fi:'Jos tilauksesi sisältää myös saatavilla olevia koruja, ne lähetetään ensin. Toinen paketti on maksuton.',hu:'Ha a rendelés készleten lévő ékszereket is tartalmaz, azokat előbb küldjük. A második csomag felár nélküli.',it:'Se il tuo ordine contiene anche gioielli disponibili, partono prima. Il secondo pacco è senza costi aggiuntivi.',nl:'Als je bestelling ook beschikbare sieraden bevat, worden die eerst verzonden. Het tweede pakket is gratis.',pl:'Jeśli zamówienie zawiera również dostępną biżuterię, zostanie ona wysłana najpierw. Druga paczka jest bez dodatkowych opłat.',sv:'Om din beställning även innehåller tillgängliga smycken skickas de först. Det andra paketet är utan extra kostnad.'};
 const reserved=new Set(Object.values(copy).flatMap(c=>[c.label,c.detail,c.count]));
 function decode(token){
  if(typeof token!=='string')return null;
  try{
   const chunks=token.split('.'),encoded=chunks[0]==='catalog2'?chunks[1]:chunks[0];
   const json=typeof Buffer!=='undefined'?Buffer.from(encoded,'base64url').toString('utf8'):new TextDecoder().decode(Uint8Array.from(atob(encoded.replace(/-/g,'+').replace(/_/g,'/')),c=>c.charCodeAt(0)));
   return JSON.parse(json);
  }catch{return null;}
 }
 function contract(item,meta){
  const id=String(item.variant_id||item.id),quantity=Number(item.quantity||1);
  const token=meta?.offer||item.properties?._solstice_preorder_v1,offer=decode(token);
  if(!offer||offer.variant!=='gid://shopify/ProductVariant/'+id){
   if(meta&&typeof meta.preorder==='boolean')return {token:null,quantity,ready:meta.preorder?0:quantity,preorder:meta.preorder?quantity:0};
   return null;
  }
  if(offer.v===2){try{return {token,...core.materialize(offer,quantity)};}catch{return null;}}
  return offer.v===1&&offer.quantity===quantity?{token,...offer}:null;
 }
 function withoutDeliveryProperties(values={}){
  return Object.fromEntries(Object.entries(values).filter(([key])=>!reserved.has(key)&&!key.startsWith('_solstice_preorder')&&key!=='_solstice_ready_qty'));
 }
 function properties(item,meta,{locale='fr',country='FR'}={}){
  const c=contract(item,meta),old=item.properties||{};
  const next=withoutDeliveryProperties(old);
  if(!c)return next;
  const language=locale.split('-')[0],text=copy[language]||copy.en;
  Object.assign(next,{...(c.token?{_solstice_preorder_v1:c.token}:{_solstice_preorder_source:'shopify-native-unverified'}),_solstice_preorder_qty:String(c.preorder),_solstice_ready_qty:String(c.ready)});
  next[text.label]=c.preorder?text.later+' '+(splitNotice[language]||splitNotice.en):(country==='FR'?text.ready:(international[language]||international.en));
  if(c.preorder){next[text.detail]=String(item.product_title||meta?.title||item.title||'');next[text.count]=String(c.preorder);}
  return next;
 }
 function summary(cart,lookup=()=>null){
  const ready=[],preorder=[];
  for(const item of cart?.items||[]){
   if(item.requires_shipping===false)continue;
   const c=contract(item,item.properties?._solstice_preorder_v1?null:lookup(String(item.variant_id||item.id)));
   if(!c)continue;
   const title=String(item.product_title||item.title||'');
   if(c.ready)ready.push({quantity:c.ready,title});if(c.preorder)preorder.push({quantity:c.preorder,title});
  }
  return {_solstice_preorder_order_version:'1',_solstice_preorder_count:String(preorder.reduce((s,i)=>s+i.quantity,0)),_solstice_ready_count:String(ready.reduce((s,i)=>s+i.quantity,0)),_solstice_preorder_items:preorder.map(i=>i.quantity+' × '+i.title).join('; '),_solstice_ready_items:ready.map(i=>i.quantity+' × '+i.title).join('; ')};
 }
 function cartItemProperties(item){
  return Object.fromEntries(Object.entries(item?.properties||{}).filter(([key,value])=>value&&!key.startsWith('_')&&!reserved.has(key)));
 }
 function deliveryMetadata(cart,metadata={}){
  const result={...metadata};
  for(const item of cart?.items||[]){
   const current=result[item.key];
   if(current&&current.quantity===item.quantity&&String(current.variantId)===String(item.variant_id))continue;
   const c=contract(item);
   if(c)result[item.key]={variantId:item.variant_id,quantity:item.quantity,state:c.preorder?'restock':'ready'};
  }
  return result;
 }
 const api={decode,contract,properties,withoutDeliveryProperties,summary,cartItemProperties,deliveryMetadata};
 if(typeof module!=='undefined')module.exports=api;
 if(!root?.document||!root.fetch)return;
 const doc=root.document,script=doc.currentScript,route=root.Shopify?.routes?.root||'/',options={locale:script?.dataset.locale||'fr',country:script?.dataset.country||'FR'},catalog=new Map();
 let cart={items:[]},navigating=false,cartInitialized=false;
 // Browser Back can restore this instance from bfcache after checkout.
 root.addEventListener('pageshow',()=>{navigating=false;});
 function register(rows){for(const row of rows||[])if(row?.id&&(row.offer||typeof row.preorder==='boolean'))catalog.set(String(row.id),row);}
 const visited=new WeakSet();
 function discover(){
  for(const element of doc.querySelectorAll('script[data-published-checkout]')){
   if(visited.has(element))continue;visited.add(element);
   try{const data=JSON.parse(element.textContent);register(data.items);if(data.cart?.items&&!cartInitialized){cart=data.cart;cartInitialized=true;}}catch{}
  }
  decorateForms();
 }
 function observeCart(value){if(value?.items&&value.total_price!==undefined)cart=value;}
 function registerDelivery(data){register(Object.values(data||{}).map(d=>({id:d.variantId,offer:d.offer,title:d.title,preorder:d.state==='restock'})));}
 function decorate(item){
  const id=String(item.variant_id||item.id),meta=catalog.get(id);
  return {...item,properties:properties(item,meta,options)};
 }
 function alterBody(body,action){
  discover();
  const form=typeof FormData!=='undefined'&&body instanceof FormData;
  if(form){
   const item={id:body.get('id'),quantity:Number(body.get('quantity')||1),properties:{}};
   for(const [key,value] of body.entries()){const match=/^properties\[(.*)\]$/.exec(key);if(match)item.properties[match[1]]=value;}
   const next=decorate(item);
   for(const key of Object.keys(item.properties))body.delete('properties['+key+']');
   for(const [key,value] of Object.entries(next.properties))body.set('properties['+key+']',value);
   return body;
  }
  if(typeof body!=='string')return body;
  let data;try{data=JSON.parse(body);}catch{return body;}
  if(action==='add'){
   if(Array.isArray(data.items))data.items=data.items.map(decorate);else data=decorate(data);
  }else if(action==='change'&&Number(data.quantity)!==0){
   const old=cart.items.find((i,n)=>String(i.key)===String(data.id)||String(i.variant_id)===String(data.id)||n+1===data.line);
   if(old){const next=decorate({...old,quantity:data.quantity??old.quantity,properties:data.properties||old.properties});data.properties=next.properties;}
  }
  return JSON.stringify(data);
 }
 function decorateForms(){
  for(const form of doc.querySelectorAll('form[action*="/cart/add"]')){
   const id=form.querySelector('[name="id"]')?.value;
   if(!id||!catalog.has(String(id)))continue;
   const item={id,quantity:Number(form.querySelector('[name="quantity"]')?.value||1),properties:{}};
   for(const input of form.querySelectorAll('[name^="properties["]')){const key=/^properties\[(.*)\]$/.exec(input.name)?.[1];if(key)item.properties[key]=input.value;}
   const next=decorate(item).properties;
   for(const key of Object.keys(item.properties))if(!Object.hasOwn(next,key)){
    for(const input of form.querySelectorAll('[name^="properties["]'))if(input.name==='properties['+key+']')input.remove();
   }
   for(const [key,value] of Object.entries(next)){
    let input=[...form.querySelectorAll('[name^="properties["]')].find(el=>el.name==='properties['+key+']');
    if(input)input.value=value;else append(form,'properties['+key+']',value);
   }
  }
 }
 const request=root.fetch.bind(root);
 root.fetch=function(input,init){
  let action=null,next=init,catalogResponse=false;
  try{const url=new URL(typeof input==='string'?input:input.url,root.location.origin);if(url.origin===root.location.origin){catalogResponse=['solstice-selection','configurator'].includes(url.searchParams.get('view'));}if(url.origin===root.location.origin)action=url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/)?.[1];}catch{}
  if(action&&init?.body){try{next={...init,body:alterBody(init.body,action)};}catch{/* Supplementary metadata must not prevent a native cart operation. */}}
  return request(input,next).then(response=>{
   if(action&&response.ok)response.clone().json().then(observeCart).catch(()=>{});
   if(catalogResponse&&response.ok)response.clone().json().then(rows=>{for(const item of rows){if(item.checkout_offers)register(item.checkout_offers);if(item.checkout_offer)register([{id:item.id,offer:item.checkout_offer,title:item.product_title||item.title}]);}}).catch(()=>{});
   return response;
  });
 };
 function append(form,name,value){const input=doc.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);}
 function addSummary(form,value){for(const [key,text] of Object.entries(summary(value,id=>catalog.get(id)))){
  let input=form.querySelector('input[name="attributes['+key+']"]');if(input)input.value=text;else append(form,'attributes['+key+']',text);
 }}
 function checkout(value=cart,url=route+'checkout'){
  if(navigating)return;navigating=true;observeCart(value);
  const form=doc.createElement('form');form.method='post';form.action=route+'cart';form.hidden=true;
  append(form,'checkout','checkout');
  const discount=new URL(url,root.location.origin).searchParams.get('discount');if(discount)append(form,'discount',discount);
  addSummary(form,value);doc.body.append(form);root.HTMLFormElement.prototype.submit.call(form);
 }
 root.SolsticePreorder={...api,register,registerDelivery,observeCart,checkout,prepare:async()=>{
   if(root.SolsticeHalloweenGift?.enabled)observeCart(await root.SolsticeHalloweenGift.sync());
   if(root.SolsticeExpiredGifts?.active)observeCart(await root.SolsticeExpiredGifts.sync());
   return cart;
  }};
 doc.addEventListener('change',decorateForms,true);
 discover();new MutationObserver(discover).observe(doc.documentElement,{childList:true,subtree:true});
 function showError(error){
  let box=doc.querySelector('[data-checkout-error]');
  if(!box){box=doc.createElement('p');box.dataset.checkoutError='';box.setAttribute('role','alert');(doc.querySelector('main')||doc.body).prepend(box);}
  box.textContent=script?.dataset.error||'Vérifiez votre panier avant de continuer.';
 }
 doc.addEventListener('submit',event=>{
  if(event.submitter?.name!=='checkout'||!event.target?.action?.includes('/cart'))return;
  addSummary(event.target,cart);
  if(root.SolsticeExpiredGifts?.active||root.SolsticeHalloweenGift?.enabled){
   event.preventDefault();root.SolsticePreorder.prepare().then(()=>checkout(cart,route+'checkout')).catch(showError);
  }
 },true);
 doc.addEventListener('click',async event=>{
  const anchor=event.target.closest?.('a[href]');if(!anchor||event.ctrlKey||event.metaKey||event.shiftKey||anchor.target==='_blank')return;
  let url;try{url=new URL(anchor.href,root.location.origin);}catch{return;}
  if(url.origin!==root.location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/.test(url.pathname))return;
  event.preventDefault();try{await root.SolsticePreorder.prepare();checkout(cart,url.href);}catch(error){showError(error);}
 },true);
})(typeof window==='undefined'?null:window);
